import { render, staticRenderFns } from "./PointGauge.vue?vue&type=template&id=80d4a600&scoped=true&"
import script from "./PointGauge.vue?vue&type=script&lang=js&"
export * from "./PointGauge.vue?vue&type=script&lang=js&"
import style0 from "./PointGauge.vue?vue&type=style&index=0&id=80d4a600&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d4a600",
  null
  
)

export default component.exports